import React, { Component ,useRef, useState } from 'react';
import * as CardTemplates from '../templates/card/index';
import { Row, Col, Alert } from 'reactstrap';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import NoDataAlertBox from '../commons/NoDataAlertBox';
import CarouselImageCard from '../templates/card/CarosuelImage';
// import React, { useRef, useState } from 'react';

const getCardData = (key, data) => {
    let _key = null;
    if (typeof key === 'string') {
        _key = key;
    }
    if (typeof key === 'object' && key.hasOwnProperty('path')) {
        _key = key.path;
    }
    if (_key !== null) {
        return ModelPropertiesParser(_key, data);
    }
    return 'Not Available';
}


class CardLayout extends Component {


    

triggerFirstAction = (cardData) => {
    const { inlineActions, workflow, triggerAction, containerIndex } = this.props;

    let actionInline = [];

    if ((containerIndex || containerIndex === 0) && inlineActions) {
        inlineActions.forEach(function(action) {

            if (
                action &&
                action.actionProperties &&
                action.actionProperties.targetContainer == containerIndex
            ) {
                actionInline.push(action);
            }

        });
    } else {
        actionInline = inlineActions;
    }

    let mainAction = null;

    actionInline.forEach(function(action) {

        if (
            action &&
            action.actionProperties &&
            action.actionProperties.entireCardClickable === true &&
            action.actionProperties.elementType !== "MENULINK"
        ) {
            if (!mainAction) {
                mainAction = action;
            }
        }

    });

    if (mainAction) {
        triggerAction(mainAction, cardData.id, workflow, cardData);
    }
};

    render() {
        const { cardConfig, cards, inlineActions, workflowId ,containerIndex} = this.props;

let actionInline = []

if ((containerIndex || containerIndex === 0) && inlineActions) {
    inlineActions.forEach(function(action){

        if(action.actionProperties.targetContainer != null &&
           action.actionProperties.targetContainer == containerIndex){
            actionInline.push(action)
        }
        else if(action.actionProperties.targetContainer === null ||
                action.actionProperties.targetContainer === undefined){
            actionInline.push(action)
        }

    })
}
else{
    actionInline = inlineActions
}

const clickable = actionInline.some(
  a => a.actionProperties && a.actionProperties.entireCardClickable
)
        if (!cardConfig) return <Alert color='warning'>Looks like the Card Layout has not been configured. Please try switching to the Table layout.</Alert>
        const { template, config } = cardConfig;
        const LoadTemplate = CardTemplates[template.value];
        const isFullWidth = config.hasOwnProperty('isFullWidth') && config.isFullWidth === true ? true : false;
        return (
            <MakeCards {...this.props} LoadTemplate={LoadTemplate} filteredActions={actionInline} isFullWidth={isFullWidth} triggerFirstAction={this.triggerFirstAction} />
        )
    }
}


const MakeCards = (props) => {
    const { LoadTemplate, isFullWidth,actionInline, cardConfig, cards, workflow: { currentItem: { typeModel: { name } } }, noDataText,noDataTextHeading } = props;
    const { config } = cardConfig;

    const _CARDS = [];
    const cardsSize = cards.getSize();

const scrollRef = useRef(null);

const getScrollAmount = () => {
  const container = scrollRef.current;
  if (!container) return 300;

  const containerWidth = container.offsetWidth;

  // Bootstrap grid logic (12 columns)
  let columns = 12;

  if (window.innerWidth >= 992) {
    columns = parseInt(lg);   // desktop
  } else if (window.innerWidth >= 768) {
    columns = parseInt(md);   // tablet
  } else {
    columns = parseInt(xs);   // mobile
  }

  const cardWidth = containerWidth / (12 / columns);

  return cardWidth; // scroll exactly 1 card
};


const arrowStyle = (position) => ({
  position: 'absolute',
  [position]: '-5px',
  top: '40%',
  transform: 'translateY(-50%)',
  background: '#fff',
  borderRadius: '50%',
  width: '44px',
  height: '44px',
  border: '1px solid #e2e8f0',
  boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
  cursor: 'pointer',
  zIndex: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
const scroll = (direction) => {
  if (!scrollRef.current) return;

  const amount = getScrollAmount();

  scrollRef.current.scrollBy({
    left: direction === 'left' ? -amount : amount,
    behavior: 'smooth'
  });
};
    if (!cardsSize || cardsSize === 0) {
        return <NoDataAlertBox typeModelName={name} noDataText={noDataText} noDataTextHeading={noDataTextHeading} {...props} />
    }
    const xs = isFullWidth ? '12' : '12';
    const md = isFullWidth ? '12' : (config.cardSize?(parseInt(config.cardSize)*3/2) + '': '6');
    const lg = isFullWidth ? '12' : (config.cardSize?config.cardSize: '3');
    let allData = [];
    for (let i = 0; i < cardsSize; i += 1) {
        let arr = {
            title:getCardData(config.cardTitle, cards.getObjectAt(i)),
            link:getCardData(config.cardExternalpath, cards.getObjectAt(i)),
            image:getCardData(config.cardImage, cards.getObjectAt(i))
        }
        allData.push(
         arr
        )
    }

        if(config && config.readllAsCarosuel){
            return <div>
                <CarouselImageCard items={allData} {...props}/>
            </div>
        }

    for (let i = 0; i < cardsSize; i += 1) {
        _CARDS.push(
          <Col 
    xs={xs} 
    md={md} 
    lg={lg} 
    key={i} 
    className={`mb-4 ${isFullWidth ? 'player-card-full-width-container' : 'player-card-container'}`}

    
onClick={(e) => {
  if (e.target.closest('.action-button-element')) return;
  props.triggerFirstAction(cards.getObjectAt(i));
}}
     style={{ cursor: 'pointer' }}
>
    <div
       
    >
        <LoadTemplate
            title={getCardData(config.cardTitle, cards.getObjectAt(i))}
            subtitle={getCardData(config.cardSubtitle, cards.getObjectAt(i))}
            description={getCardData(config.cardDescription, cards.getObjectAt(i))}
            label={getCardData(config.cardLabel, cards.getObjectAt(i))}
            data={cards.getObjectAt(i)}
            image={getCardData(config.cardImage, cards.getObjectAt(i))}
            allDataImages={allData}
          inlineActions={actionInline}
           containerIndex={props.containerIndex}
            {...props}
        />
    </div>
</Col>
)
    }
    if(config.horizontalViewMode){
    return    <div style={{ position: 'relative' }}>

  {/* LEFT ARROW */}
 <button
  type="button"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    scroll('left');
  }}
  style={arrowStyle('left')}
>
  <i className="fa fa-chevron-left" />
</button>

  {/* SCROLLABLE ROW */}
  <div
    ref={scrollRef}
    style={{
      overflowX: 'auto',
      display: 'flex',
      gap: '16px',
      scrollBehavior: 'smooth'
    }}
  >
    {_CARDS}
  </div>

  {/* RIGHT ARROW */}
  <button
  type="button"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    scroll('right');
  }}
  style={arrowStyle('right')}
>
  <i className="fa fa-chevron-right" />
</button>

</div>
    }
    return <Row className={config.isTimelineView ? 'timeline-view' : config.horizontalViewMode ? 'horizontalScrollForCards': ''}>
        {_CARDS}
    </Row>

}

export default CardLayout;